module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "ui secondary inverted menu nav no-print",
    class: {
      "mode-offline": !_vm.is_online, "mode-debug": _vm.is_debug
    }
  }, [_c('router-link', {
    staticClass: "item brand-logo hide-in-mobile",
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/dist/logo.svg"
    }
  }), _c('branch-label', {
    attrs: {
      "small": "small"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_online),
      expression: "!is_online"
    }],
    staticClass: "item"
  }, [_vm._v("离线模式"), _c('el-tooltip', {
    attrs: {
      "content": "当前处于离线模式，系统所呈现的数据可能与实际不一致，但你仍然可以查看已经离线的数据。",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "icon help circle semitrans"
  })])], 1), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("概况")]), (_vm.$permission.has("basic.view.bills")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/bills"
    }
  }, [_vm._v("收支"), (false) ? _c('div', {
    staticClass: "floating ui olive mini circular label"
  }, [_vm._v(_vm._s(0))]) : _vm._e()]) : _vm._e(), _c('el-popover', {
    ref: "records",
    attrs: {
      "popper-class": "menu",
      "placement": "bottom-start",
      "width": "200",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "ui fluid vertical menu"
  }, [(_vm.$permission.has("basic.view.customers")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/customers"
    }
  }, [_vm._v("住户")]) : _vm._e(), (_vm.$permission.has("basic.view.properties")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/properties"
    }
  }, [_vm._v("仓库")]) : _vm._e(), (_vm.$permission.has("basic.view.charges")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/charges"
    }
  }, [_vm._v("水电充值记录")]) : _vm._e(), (_vm.$permission.has("basic.record")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/records/meters"
    }
  }, [_vm._v("公寓水电表记录")]) : _vm._e()], 1)]), _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:records",
      arg: "records"
    }],
    staticClass: "ui dropdown item"
  }, [_vm._v("记录"), _c('i', {
    staticClass: "dropdown icon"
  })]), (_vm.$permission.has("basic.reports")) ? _c('el-popover', {
    ref: "reports",
    attrs: {
      "popper-class": "menu",
      "placement": "bottom-start",
      "width": "200",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "ui fluid vertical menu"
  }, [(_vm.$permission.has("basic.reports.basic")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/reports"
    }
  }, [_vm._v("基础信息")]) : _vm._e(), (_vm.$permission.has("basic.reports.meters")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/reports/meters"
    }
  }, [_vm._v("公寓水电使用情况")]) : _vm._e(), (_vm.$permission.has("basic.reports.charges")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/reports/charges"
    }
  }, [_vm._v("水电充值报表")]) : _vm._e(), (_vm.$permission.has("basic.reports.summary")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/reports/summary"
    }
  }, [_vm._v("年度汇总报表")]) : _vm._e(), (_vm.$permission.has("basic.reports.subjects")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/reports/subjects"
    }
  }, [_vm._v("科目汇总报表")]) : _vm._e(), (_vm.$permission.has("basic.reports.utilities_monitor")) ? _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/reports/utilities_monitor"
    }
  }, [_vm._v("水电监控")]) : _vm._e()], 1)]) : _vm._e(), (_vm.$permission.has("basic.view.reports")) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:reports",
      arg: "reports"
    }],
    staticClass: "ui dropdown item hide-in-mobile"
  }, [_vm._v("报表"), _c('i', {
    staticClass: "dropdown icon"
  })]) : _vm._e(), (_vm.contract_draft_keys.length) ? [_c('el-popover', {
    ref: "contract_drafts",
    attrs: {
      "placement": "bottom",
      "width": "400",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "ui relaxed divided list draft-list"
  }, _vm._l((_vm.contract_draft_list), function(info) {
    return _c('div', {
      staticClass: "item"
    }, [_c('i', {
      staticClass: "mi",
      on: {
        "click": function($event) {
          _vm.contract_draft_delete(info.key)
        }
      }
    }, [_vm._v("delete")]), _c('div', {
      staticClass: "header",
      on: {
        "click": function($event) {
          _vm.contract_draft_go(info.key)
        }
      }
    }, [_vm._v(_vm._s(info.no))]), _c('span', {
      on: {
        "click": function($event) {
          _vm.contract_draft_go(info.key)
        }
      }
    }, [_vm._v(_vm._s(info.time))])])
  }))]), _c('a', {
    directives: [{
      name: "popover",
      rawName: "v-popover:contract_drafts",
      arg: "contract_drafts"
    }],
    staticClass: "item"
  }, [_vm._v("合同草稿"), _c('div', {
    staticClass: "floating ui olive mini circular label"
  }, [_vm._v(_vm._s(_vm.contract_draft_keys.length))])])] : _vm._e(), (_vm.$permission.has("system.admin")) ? _c('router-link', {
    staticClass: "item hide-in-mobile",
    attrs: {
      "to": "/admin"
    }
  }, [_vm._v("管理")]) : _vm._e(), _c('a', {
    staticClass: "item",
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("刷新")]), _c('div', {
    staticClass: "item narrow"
  }, [_c('div', {
    staticClass: "ui transparent input inverted short",
    class: {
      error: _vm.quick_nav_input_error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quick_nav_input),
      expression: "quick_nav_input"
    }],
    attrs: {
      "type": "text",
      "placeholder": "房间号..."
    },
    domProps: {
      "value": (_vm.quick_nav_input)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.quick_nav_go()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quick_nav_input = $event.target.value
      }
    }
  })])]), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$router.fullPath === "/"),
      expression: "$router.fullPath === \"/\""
    }],
    staticClass: "item icon",
    on: {
      "click": _vm.load_summary
    }
  }, [_c('i', {
    staticClass: "icon refresh"
  })]), _c('el-popover', {
    ref: "profile",
    attrs: {
      "placement": "bottom-end",
      "width": "250",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "profile ui comments"
  }, [_c('div', {
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.$formatters.user_name(_vm.$user)))]), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$formatters.user_role(_vm.$user)))]), _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("登出")]), _c('router-link', {
    staticClass: "profile",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("信息")])], 1)])])])]), _c('div', {
    staticClass: "right menu"
  }, [_c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:profile",
      arg: "profile"
    }],
    staticClass: "item hide-in-mobile"
  }, [_vm._v(_vm._s(_vm.$formatters.user_name(_vm.$user)))]), _c('a', {
    staticClass: "item icon",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon sign out"
  })])])], 2), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "router-container"
  }, [_c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dee32ee","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Main.vue
// module id = 430
// module chunks = 0